import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.RtpWithdrawResponse,
  RtpWithdraw: (params: vp.RtpWithdrawRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostRtpWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldRtpWithdraw, setShouldRtpWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.RtpWithdrawRequest>({
    AccountNumber: '',
    ABARoutingNumber: '',
    Amount: 0,
    RecipientName: '',
    ClientReferenceNumber: '',
  });
  const [response, setResponse] = useState<vp.RtpWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
  });

  useEffect(() => {
    if (!shouldRtpWithdraw) return () => {};

    const PostRtpWithdraw = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postRtpWithdraw(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldRtpWithdraw) void PostRtpWithdraw();
    setShouldRtpWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldRtpWithdraw]);

  return [
    response,
    (_params: vp.RtpWithdrawRequest) => {
      setParams(_params);
      setShouldRtpWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
      });
      setShouldRtpWithdraw(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostRtpWithdraw);
